module.exports = __webpack_public_path__ + "img/au-pay.c81d21b1.png";